import InnerComponent from '@Components/Production/JobWorks';
import orgContainer from '@Components/AppContainer';

const ListJobWorks = () => ((orgContainer(InnerComponent)));
export default ListJobWorks;
